import { InsertDriveFile as FileIcon, Photo as PhotoIcon } from '@mui/icons-material';
import React from 'react';

import keycloak from '../keycloak';
import { axiosInstance } from '../redux/configureStore';

export async function downloadAttachment(src) {
    const response = await axiosInstance.get(src, {
        withCredentials: true,

        headers: {
            Authorization: `bearer ${keycloak.token}`,
            'Content-Type': 'image/*',
        },
        responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
}

export async function saveAttachment(path, filename) {
    const url = await downloadAttachment(path);
    const link = document.createElement('a');
    link.setAttribute('download', filename);
    link.href = url;
    link.click();
}

export async function openAttachment(path) {
    const url = await downloadAttachment(path);
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.href = url;
    link.click();
}

export function revokeObjectUrl(url) {
    if (url !== undefined) {
        URL.revokeObjectURL(url);
    }
}

export function getIcon(type) {
    if (typeof type === 'string' && type.startsWith('image')) {
        return <PhotoIcon />;
    }
    return <FileIcon />;
}
